// On the search filters we only display the waist size. This is used to make sure when a
// specific waist size is selected in the UI we also add that waist/length pair below for 
// the denim products to the filter as well. If we didn't do this, when someone selects a 32 waist 
// then none of the denim sizes would match since the filter requires an exact match and
// waist/length != waist

const ADDITIONAL_SIZES_MUTATION = (size) => {
    const sizes = ["26/28","27/28","28/28","29/28","30/28","32/28","34/28","36/28","38/28","40/28","26/32","27/32","28/32","32/32","30/32","36/32","29/32","38/32","34/32","40/32","25/28","25/32","24/28","24/32"];
    return sizes.filter(_size => {
      const waist = _size.split('/')[0];
      if (size === waist) return _size;
    })
  }

export function filterStringBuilder(filterValues) {
    const finalString = [];
    const typeString = [];
    const colourString = [];
    const sizeString = [];
    const categoryString = [];

    filterValues.type.map((type, idx) => {
      typeString.push(`tags:"${type}"`)
    });

    filterValues.colourTags.map((colour, idx) => {
      colourString.push(`sanity.shopifyProducts.colour.tags.value:"${colour}"`)
    });

    filterValues.size.map((size, idx) => {
      const additionalSizes = ADDITIONAL_SIZES_MUTATION(size);
      if (additionalSizes.length > 0) {
        sizeString.push(`variants.selectedOptions.value:"${additionalSizes}"`)
      }
      sizeString.push(`variants.selectedOptions.value:"${size}"`)
    });

    filterValues.category.map((category, idx) => {
      categoryString.push(`tags:"${category}"`);
    });

    if (typeString.length) {
      finalString.push(`(${typeString.join(' OR ')})`)
    }

    if (colourString.length) {
      finalString.push(`(${colourString.join(' OR ')})`)
    }

    if (sizeString.length) {
      finalString.push(`(${sizeString.join(' OR ')})`);
    }

    if (categoryString.length) {
      finalString.push(`(${categoryString.join(' OR ')})`)
    }

    if (finalString.length) {
      return `(availableForSale: true) AND ${finalString.join(' AND ')}`
    }
    return '';    
}